/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Visibility_Disabled_TitleInputs */

const en_cas_visibility_disabled_title = /** @type {(inputs: Cas_Visibility_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capital Account Statement Visibility has changed`)
};

/**
* | output |
* | --- |
* | "Capital Account Statement Visibility has changed" |
*
* @param {Cas_Visibility_Disabled_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_visibility_disabled_title = /** @type {((inputs?: Cas_Visibility_Disabled_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Visibility_Disabled_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_visibility_disabled_title(inputs)
});